const typesOfChoices = {
  onlyElements: 0,
  groupsEndElements: 1,
  onlyGroups: 2,
};

export default typesOfChoices;
